import { Component } from 'react';
import { compose } from 'recompose';
import { ChartFragment, Section } from 'models/api-response';
import { FormFieldInputType } from 'models/enum';
import { ChartActionsComponentProps, ChartComponentProps, ChartMetaFormField } from 'models/ui';
import { chartHelper } from 'helpers';
import { chartService } from 'services';
import { withChartLogic } from 'components/common';
import withSavedPatientChartsPage from 'components/features/shared/withSavedPatientChartsPage';
import { FormField, SectionTitle } from './constants';
import NeurologicalInterventionsView from './NeurologicalInterventionsView';
import { Title } from '../shared/constants';

class NeurologicalInterventions extends Component<ChartComponentProps> {
  static displayName = 'NeurologicalInterventions';

  componentDidMount() {
    this.props.initState(this.buildDefaultFormFields());
  }

  buildDefaultFormFields = (): Map<string, ChartMetaFormField> => {
    const { createFormField } = chartHelper;
    const dataMap = new Map();

    const multiselectDropdowns = [
      FormField.NEURO_INTERVENTIONS_CARE,
      FormField.SEIZURE_PRECAUTIONS,
      FormField.EXTRAPYRAMIDAL_SIDE_EFFECTS,
      FormField.NEUROLEPTIC_MALIGNANT_SYNDROME,
      FormField.PATIENT_RESPONSE
    ];

    dataMap.set(FormField.NO_CARE, createFormField({ name: FormField.NO_CARE, type: FormFieldInputType.CHECK_BOX }));
    multiselectDropdowns.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.MULTISELECT_DROPDOWN })));
    dataMap.set(FormField.CARE_NOTES, createFormField({ name: FormField.CARE_NOTES, type: FormFieldInputType.TEXT_AREA }));
    return dataMap;
  };

  createSections = (): Section[] => {
    const { formFieldMap } = this.props;
    return [
      chartHelper.buildSection({ sectionTitle: SectionTitle.NEUROLOGICAL_INTERVENTIONS, fields: [FormField.NO_CARE], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.NEURO_INTERVENTIONS_CARE, fields: [FormField.NEURO_INTERVENTIONS_CARE], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.SEIZURE_PRECAUTIONS, fields: [FormField.SEIZURE_PRECAUTIONS], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.EXTRAPYRAMIDAL_SIDE_EFFECTS, fields: [FormField.EXTRAPYRAMIDAL_SIDE_EFFECTS], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.NEUROLEPTIC_MALIGNANT_SYNDROME, fields: [FormField.NEUROLEPTIC_MALIGNANT_SYNDROME], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.PATIENT_RESPONSE, fields: [FormField.PATIENT_RESPONSE], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.CARE_NOTES, fields: [FormField.CARE_NOTES], formFieldMap })
    ];
  };

  buildFragment = () => {
    const record = {
      chartTitle: Title.SYSTEM_NURSING_INTERVENTIONS,
      fragmentTitle: SectionTitle.NEUROLOGICAL_INTERVENTIONS,
      records: this.createSections()
    };
    const cleanRecord = chartService.systemAssessment.removeEmptyRecords(record);
    const basicInfo = chartService.createBaseFragment({ chartingTime: this.props.chartingTime });
    return { ...basicInfo, chartData: cleanRecord } as ChartFragment;
  };

  handleSaveClick = () => {
    this.props.saveChart([this.buildFragment()], { afterSave: this.props.backToSourceLocation || this.props.navigateToSavedPatientCharting });
  };

  render() {
    const chartActionsProps: ChartActionsComponentProps = {
      enableDisplayRecordsButton: this.props.enableDisplayRecordsButton,
      enableSaveButton: this.props.hasUnsavedChanges,
      onCancelClick: () => this.props.handleDiscardClick(undefined, this.buildDefaultFormFields()),
      onDisplayRecordsClick: this.props.displayAuthoringData,
      onSaveClick: this.handleSaveClick
    };
    const viewProps = {
      chartActionsProps,
      formFieldMap: this.props.formFieldMap,
      formSubmittedCount: this.props.formSubmittedCount
    };
    return <NeurologicalInterventionsView {...viewProps} />;
  }
}

export { NeurologicalInterventions as BaseNeurologicalInterventions };
export default compose(withSavedPatientChartsPage, withChartLogic)(NeurologicalInterventions);
